class Modal {
    constructor(options = {}) {
        this.options = options;
        this.parent = this.createParentElement();
        this.modal = this.createModalElement();
        this.closeButton = options.closeButton || null;
        this.closeOverlay = options.closeOverlay || false;
        this.init();
    }
    open(e) {
        if (e)
            e.stopPropagation();
        this.parent.classList.add('is-open');
        setTimeout(() => {
            this.parent.style.opacity = '1';
        }, 50);
    }
    close(e) {
        if (e)
            e.stopPropagation();
        this.parent.style.opacity = '0';
        setTimeout(() => {
            this.parent.classList.remove('is-open');
        }, 300);
    }
    insert() {
        this.parent.appendChild(this.modal);
        document.body.appendChild(this.parent);
    }
    destroy() {
        this.parent.parentNode.removeChild(this.parent);
        delete this.parent;
        delete this.modal;
    }
    addOpenButton(element) {
        element.addEventListener('click', (e) => { this.open(e); });
    }
    addCloseButton(element) {
        element.addEventListener('click', (e) => { this.close(e); });
    }
    addParentClass(...classes) {
        classes.forEach(value => {
            this.parent.classList.add(value);
        });
    }
    addModalClass(...classes) {
        classes.forEach(value => {
            this.modal.classList.add(value);
        });
    }
    addChild(child) {
        this.modal.appendChild(child);
    }
    addHTML(html) {
        const element = document.createElement('div');
        element.innerHTML = html;
        this.modal.appendChild(element);
    }
    addYoutubeVideo(options) {
        options.videoID = options.videoID || false;
        options.autoPlay = options.autoPlay || 0;
        options.allowFullScreen = options.allowFullScreen || false;
        options.controls = options.controls || 0;
        options.showInfo = options.showInfo || 0;
        options.start = options.start || 0;
        options.color = options.color || null;
        options.list = options.list || null;
        options.listType = options.listType || null;
        options.loop = options.loop || 0;
        options.height = options.height || 500;
        options.width = options.width || 500;
        let url = `https://www.youtube.com/embed/${options.videoID}?enablejsapi=1&version=3&playerapiid=ytplayer?`;
        const attributes = ['height', 'width', 'breakpoints', 'allowFullScreen'];
        for (const key in options) {
            if (options[key] !== null && !attributes.includes(key) && Object.prototype.hasOwnProperty.call(options, key)) {
                const lowerKey = key.toLowerCase();
                url += `${lowerKey}=${options[key]}&`;
            }
        }
        url = url.replace(/&$/, '');
        const iframe = document.createElement('iframe');
        iframe.setAttribute('src', url);
        iframe.setAttribute('frameborder', (0).toString());
        iframe.setAttribute('height', options.height.toString());
        iframe.setAttribute('width', options.width.toString());
        if (options.breakpoints)
            this.setIframeBreakpoints(iframe, options.breakpoints);
        if (options.autoPlay)
            iframe.setAttribute('autoplay', '');
        if (options.allowFullScreen)
            iframe.setAttribute('allowfullscreen', '');
        this.modal.appendChild(iframe);
    }
    setIframeBreakpoints(iframe, breakpoints) {
        const keys = [];
        for (const key in breakpoints) {
            if (Object.prototype.hasOwnProperty.call(breakpoints, key)) {
                keys.push(key);
            }
        }
        for (let i = 0; i < keys.length; i++) {
            const size = keys[i];
            const upperSize = keys[i + 1] || null;
            const breakpoint = breakpoints[size];
            let mediaQuery;
            if (upperSize) {
                mediaQuery = window.matchMedia(`(min-width: ${size}px) and (max-width: ${upperSize}px)`);
            }
            else {
                mediaQuery = window.matchMedia(`(min-width: ${size}px)`);
            }
            const onChange = (mediaQuery) => {
                if (mediaQuery.matches) {
                    iframe.setAttribute('height', breakpoint.height.toString());
                    iframe.setAttribute('width', breakpoint.width.toString());
                }
            };
            mediaQuery.addListener(onChange);
            onChange(mediaQuery);
        }
    }
    createParentElement() {
        const parent = document.createElement('div');
        parent.classList.add('lnd-modal-overlay');
        return parent;
    }
    createModalElement() {
        const modal = document.createElement('div');
        modal.classList.add('lnd-modal-box');
        modal.addEventListener('click', e => e.stopPropagation());
        return modal;
    }
    setOverlayEvent() {
        if (this.closeOverlay) {
            this.parent.addEventListener('click', (e) => { this.close(e); });
        }
    }
    appendCloseElement() {
        const element = document.createElement('div');
        element.classList.add('lnd-modal-close');
        this.modal.appendChild(element);
        this.addCloseButton(element);
    }
    setTransition() {
        this.parent.style.transition = this.options.transition || void 0;
    }
    init() {
        this.setOverlayEvent();
        if (this.closeButton) {
            this.appendCloseElement();
        }
        this.setTransition();
    }
}
export { Modal };
